module.exports = __webpack_public_path__ + "static/img/B110-GEN_A.5fd6ff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/B110-GEN_A.jpg
// module id = 7UBc
// module chunks = 0